import React from 'react';
import './MarqueeStrip.css';

const ITEMS = [
  'DIGITAL ART',
  '·',
  'CHARACTER DESIGN',
  '·',
  'ANIME ILLUSTRATION',
  '·',
  'DAILY PRACTICE',
  '·',
  'COMMISSIONS',
  '·',
  '2 YEARS IN',
  '·',
];

function MarqueeContent() {
  return (
    <span className="marquee-content" aria-hidden="true">
      {ITEMS.map((item, i) => (
        <span key={i} className={item === '·' ? 'marquee-dot' : 'marquee-word'}>
          {item}
        </span>
      ))}
    </span>
  );
}

export default function MarqueeStrip({ dark = true, speed = 35 }) {
  return (
    <div
      className={`marquee-strip ${dark ? 'marquee-dark' : 'marquee-light'}`}
      aria-label="Skills and focus areas"
    >
      <div className="marquee-track" style={{ '--speed': `${speed}s` }}>
        <MarqueeContent />
        <MarqueeContent />
        <MarqueeContent />
      </div>
    </div>
  );
}
